'use client';

import { useEffect } from 'react';
import Link from 'next/link';

/**
 * Route-level error boundary. Without this, a render error in any page showed
 * Next's bare crash screen with no way to recover.
 */
export default function Error({ error, reset }) {
  useEffect(() => {
    console.error('Route error:', error);
  }, [error]);

  return (
    <main className="ui-status-page" id="main">
      <div className="ui-status-card" role="alert">
        <div className="ui-status-code">Oops</div>
        <h1>Something went wrong</h1>
        <p>
          An unexpected error occurred while loading this page. Your data is safe - try again, and
          if it keeps happening let your administrator know.
        </p>
        {process.env.NODE_ENV !== 'production' && error?.message && <pre>{error.message}</pre>}
        <div className="ui-status-actions">
          <button type="button" className="primary" onClick={() => reset()}>Try again</button>
          <Link href="/" className="secondary">Go to home</Link>
        </div>
      </div>
    </main>
  );
}
